"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/casting/Vacuum-Casting/From-Prototyping-to-Production";

const ITEMS = [
	{ keyPrefix: "prototypingToProductionCard1", icon: `${IMAGE_BASE}/concept-validation.svg` },
	{ keyPrefix: "prototypingToProductionCard2", icon: `${IMAGE_BASE}/functional-prototyping.svg` },
	{ keyPrefix: "prototypingToProductionCard3", icon: `${IMAGE_BASE}/low-volume-production.svg` },
	{ keyPrefix: "prototypingToProductionCard4", icon: `${IMAGE_BASE}/mass-production.svg` },
] as const;

export default function PrototypingToProduction() {
	const t = useTranslations("new-vacuum-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("prototypingToProductionTitle")}
					</h2>
					<p className="mx-auto mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
						{t("prototypingToProductionDesc")}
					</p>
				</header>

				<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
					{ITEMS.map((item) => (
						<div key={item.keyPrefix} className="flex flex-col items-center text-center">
							<div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-[#eef7e2] sm:h-24 sm:w-24">
								<Image
									src={item.icon}
									alt={t(`${item.keyPrefix}Alt`)}
									width={48}
									height={48}
									className="h-10 w-10 sm:h-12 sm:w-12"
								/>
							</div>
							<h3 className="mb-2 text-lg font-bold text-black sm:mb-3 sm:text-xl">
								{t(`${item.keyPrefix}Title`)}
							</h3>
							<p className="text-sm leading-relaxed text-black md:text-base">
								{t(`${item.keyPrefix}Desc`)}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
